import { render, staticRenderFns } from "./RecommendedOffers.vue?vue&type=template&id=bf51bb70&scoped=true&"
import script from "./RecommendedOffers.vue?vue&type=script&lang=js&"
export * from "./RecommendedOffers.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedOffers.vue?vue&type=style&index=0&id=bf51bb70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf51bb70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf51bb70')) {
      api.createRecord('bf51bb70', component.options)
    } else {
      api.reload('bf51bb70', component.options)
    }
    module.hot.accept("./RecommendedOffers.vue?vue&type=template&id=bf51bb70&scoped=true&", function () {
      api.rerender('bf51bb70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/RecommendedOffers.vue"
export default component.exports